/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Sales {

    import fld = RateFixingItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class RateFixingItemsEditor extends _Ext.ItemGridEditor<RateFixingItemsRow> {


        protected getColumnsKey() { return "Sales.RateFixingItems"; }
        protected getDialogType() { return RateFixingItemsDialog; }
        protected getLocalTextPrefix() { return RateFixingItemsRow.localTextPrefix; }
        protected form: RateFixingItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public TransDate: Date;
        public ExchangeRate: number;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });

            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as RateFixingDialog).CalculateAmountandTax( );
                }
            });
        }
        

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);

            var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            Department.referencedFields = [fld.DepartmentId];
            Department.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.DepartmentId, OMS.DepartmentMasterRow.getLookup(), this);

            
            Q.first(columns, x => x.field === fld.Discount).format = num;
            Q.first(columns, x => x.field === fld.WstPer).format = num;


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

       
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('This will effect Stock and can not be undone, Are you sure want to delete? ', () => { 
                            var id = this.id(item); 
                        this.view.deleteItem(id);
                        (this.parentDialog as RateFixingDialog).CalculateAmountandTax( );
                        //}

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }

        
        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject, ) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            let _value = ValidateEditorFields(field, input, text, oldText);
            let value: number;
            if (q.isNumber(_value))
                value = parseFloat(_value.toString());
            else
                return false;

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as RateFixingDialog).CalculateAmountandTax( );


            let returnvalue: string = "";
            if (input.hasClass('numeric'))
                returnvalue = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                returnvalue = Q.formatNumber(value, '0');

            input.val(returnvalue).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion


        setMasterValues() {
            this.RateListId = (this.parentDialog as RateFixingDialog).RateListId;
            this.LaborListId = (this.parentDialog as RateFixingDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as RateFixingDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as RateFixingDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as RateFixingDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as RateFixingDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as RateFixingDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as RateFixingDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as RateFixingDialog).form.PartyId.value);
        }

        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.ProductSelectGrid;

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {

                    this.setMasterValues();

                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                            FilterItems: TabAurous.ItemSelection.JMS
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        var self = this;
                        var orddetails = []; 
                        var companyId = Q.Authorization.userDefinition.CompanyId; 
                        
                        var userDetails = Q.Authorization.userDefinition;

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value) {
                            var PrdId = value.ProductId;
                            var AtbId = value.AttributeId;
                            var bomdetails = [];
                            var labordetail = [];
                            var Weight = value.Weight == undefined ? 1 : value.Weight;
                            var PrdDetails = value;
                        
                         
                            // #endregion

                            // #region Rate, Tax , SKU & Labor 
                            var Rate = 0;
                            var LaborRate = 0;

                            
                            var purity = 0;
                            var pureweight = 0;
                            if (!value.HasBom) {
                                Q.reloadLookup(OMS.MetalRateMasterRow.lookupKey)
                                var MRate = OMS.MetalRateMasterRow.getLookup().items.filter(x => x.MetalTypeId == PrdDetails.MetalId && x.RateTypeId == 33
                                    && x.CompanyId == userDetails.CompanyId && Q.formatDate(x.FromDate, "dd/MM/yyyy") <= Q.formatDate(self.TransDate, "dd/MM/yyyy"));
                                Rate = MRate.pop().Rate;
                                var KaratId = Q.toId(value.KaratId);
                                var puritydetails: OMS.AttributeMasterRow;
                                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                                    puritydetails = response.Entity
                                }, { async: false });
                                var std = puritydetails.StdPurity;
                                purity = std;
                                if (value.Purity == 0)
                                    value.Purity = std;

                            }

                            if (!value.HasBom) {
                                purity = value.Purity;
                                pureweight = Weight * purity;
                            }

                            //Calculate Tax Amount
                            //var TAmount = ((Rate + LaborRate) * ItemTax[1]) / 100;

                            var purchase: RateFixingItemsRow = {
                                ProductId: PrdId,
                                AttributeId: AtbId,
                                Line_No: value.Line_No,
                                PartyId: self.PartyId,
                                SKU: value.SKU,
                                DepartmentId: value.DepartmentId,
                                ProductCode: value.ProductCode,
                                ProductName: value.ProductName,
                                ItemTypeId: value.ItemTypeId,
                                CategoryId: value.CategoryId,
                                ProductTypeId: value.ProductTypeId,
                                SubCategoryId: value.SubCategoryId,
                                BrandId: value.BrandId,
                                SuperTypeId: value.SuperTypeId,
                                CollectionId: value.CollectionId,
                                UnitRate: Rate,
                                UnitLabour: LaborRate,
                                Pieces: 1,
                                Weight: Weight,
                                OtherPieces: value.OtherPieces,
                                OtherWeight: value.OtherWeight,
                                StonePieces: value.StonePieces,
                                StoneWeight: value.StoneWeight,
                                NetWeight: value.NetWeight,
                                TaxCode: value.TaxCode,
                                NetAmount: PrdDetails.HasBom ? (Rate + LaborRate) * 1 : (Rate * Weight) * purity,
                                GrossAmount: PrdDetails.HasBom ? (Rate + LaborRate) * 1 : (Rate * Weight) * purity,
                                DiamondPieces: value.DiamondPieces,
                                DiamondWeight: value.DiamondWeight,
                                CalcOnId: value.CalcOnId,
                                //BOMDetails: bomdetails,
                                //LaborDetails: labordetail,
                                CompanyId: companyId,
                                
                                HSN: value.HSN,
                                Purity: purity,
                                PureWeight: pureweight,
                                HasBom: value.HasBom



                            };
                            orddetails.push(purchase);

                        }); 
                        for (let orderDetail of orddetails) {
                            orderDetail[this.getIdProperty()] = "`" + this.nextId++; 
                            this.view.addItem(orderDetail);
                        }

                    }
                    // #endregion

                    pickerDialog.dialogOpen();
                }
            }); 
            return buttons;
        } 
    }
}